<div class="it-editorwrap">
	<div class="it-ln" #ln>
		<div class="it-lnline" *ngFor="let n of bodyLineNumbers">{{ n }}</div>
	</div>

	<textarea #bodyTa class="it-codearea it-codearea-numbered" [value]="value" (input)="onInput($any($event.target).value)" (scroll)="syncBodyScroll()" placeholder="{ }" wrap="off" spellcheck="false"></textarea>
</div>
